import { call } from 'redux-saga/effects';

let initModule = null;
export function* initPurchaseAdditionalFiber({ payload }) {
  if (!initModule) {
    initModule = yield call(() => import('./init'));
  }
  // llamada a modulo
  yield call(initModule.initPurchaseAdditionalFiber, { payload });
}
let setInfoModule = null;
export function* setInfoAdditionalFiber({ payload }) {
  if (!setInfoModule) {
    setInfoModule = yield call(() => import('./set-info'));
  }
  // llamada a modulo
  yield call(setInfoModule.setInfoAdditionalFiber, { payload });
}
let checkOutModule = null;
export function* checkoutAdditionalFiber({ payload }) {
  if (!checkOutModule) {
    checkOutModule = yield call(() => import('./checkout'));
  }
  // llamada a modulo
  yield call(checkOutModule.checkoutAdditionalFiber, { payload });
}
let processOrderModule = null;
export function* processOrderAdditionalFiber() {
  if (!processOrderModule) {
    processOrderModule = yield call(() => import('./process-order'));
  }
  // llamada a modulo
  yield call(processOrderModule.processOrderAdditionalFiber, {});
}
let sendPurchaseOtpModule = null;
export function* sendPurchaseOtpAdditionalFiber({ payload }) {
  if (!sendPurchaseOtpModule) {
    sendPurchaseOtpModule = yield call(() => import('./send-purchase-otp'));
  }
  // llamada a modulo
  yield call(sendPurchaseOtpModule.sendPurchaseOtpAdditionalFiber, {
    payload,
  });
}
let validatePurchaseOtpModule = null;
export function* validatePurchaseOtpAdditionalFiber({ payload }) {
  if (!validatePurchaseOtpModule) {
    validatePurchaseOtpModule = yield call(() =>
      import('./validate-purchase-otp')
    );
  }
  // llamada a modulo
  yield call(validatePurchaseOtpModule.validatePurchaseOtpAdditionalFiber, {
    payload,
  });
}
